import React from 'react'
import PropTypes from 'prop-types'
import TooltipF from '../../TooltipF'

export default function Icon(props) {
    const styles = {
    }
    if(props?.iconSize){
        styles['--width'] = `${props?.iconSize}px`
        styles['--height'] = `${props?.iconSize}px`
    }
    const renderIcon = () =>{
        return(
            <i className={`common_icon ${props?.className} ${props?.onClick?"c-pointer":""}`} onClick={props?.onClick} style={{...props?.style, ...styles, "--icon-url": `url(${props?.icon})` }}/>
        )
    }
    if(props?.title){
        return(
            <TooltipF title={props?.title} placement={props?.placement}>
                {renderIcon()}
            </TooltipF>
        )
    }
    return renderIcon();
}
Icon.propTypes = {
    size:"sm" | "md" | "nm" | "lg" | "xl",
    iconSize: PropTypes.number,
    icon: PropTypes.any,
    className: PropTypes.any,
    title: PropTypes.any,
    placement: PropTypes.any,
    onClick: PropTypes.func,
}